export const getParamsFromState = (inputAndOutput, whitelistUrlParams) => {
  const paramsObj = {};
  for (const prop of whitelistUrlParams) {
    const filteredValue = inputAndOutput[prop] ?? 'nullOrUndefined';
    if (filteredValue !== 'nullOrUndefined') paramsObj[prop] = filteredValue;
  }
  return '?' + new URLSearchParams(paramsObj).toString();
};
